export default "__VITE_ASSET__CczLMyNH__"